import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Input from '../../modules/Input';
import InputGroup from '../../modules/InputGroup';

import * as formScroller from '../../../services/forms/scroller';

class SearchUsers extends React.Component {

    _onKeyDown(e) {
        if (e.nativeEvent.code === 'Enter') {
            e.preventDefault();
        }
    }

    render() {

        return (
            <div>
                <form>
                    <InputGroup>
                        <Field
                            onKeyDown={this._onKeyDown}
                            name="searchText"
                            component={Input}
                            type="text"
                            label="Search"
                        />
                    </InputGroup>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'search-users',
    onSubmitSuccess: formScroller.scrollToTop,
    onSubmitFail: formScroller.scrollToFirstError
})(SearchUsers);